import React from 'react'
import styled from 'styled-components'
import { UIStyles } from '../../theme'
import moment from 'moment'
import { pillLooks } from '../UIComponents/StyledButtons'

const WarningText = styled.p`
  color: ${UIStyles.whiteColor};
  font-size: 18px;
  text-align: center;
  width: 100%;
  margin: 25px;
`

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
`

const StyledButton = styled.button`
  padding: 6px 12px;
  border: none;
  margin: 0 40px;
  ${props => pillLooks[props.pill]};
`

export default function ExtraStatisticsFetchConfirmationModal({ t, closeModal, from, to, selectedFieldsIds, fetchTemporalEvolutionStatistics }) {
  const formattedFrom = moment(from).format('YYYY-MM-DD')
  const formattedTo = moment(to).format('YYYY-MM-DD')

  const confirmHandler = () => {
    closeModal()
    fetchTemporalEvolutionStatistics({ fieldIds: selectedFieldsIds, from: formattedFrom, to: formattedTo })
  }

  return (
    <Wrapper>
      <WarningText>{t('current selection could take a moment to process')}</WarningText>
      <StyledButton pill="cancel" onClick={closeModal}>
        {t('edit range')}
      </StyledButton>
      <StyledButton pill="confirm" onClick={confirmHandler}>
        {t('confirm')}
      </StyledButton>
    </Wrapper>
  )
}
